
<script>
import UserRepository from './repos/UserRepository'
import AuthRepository from './repos/AuthRepository'
import SectorRepository from './repos/SectorRepository'
import RoleRepository from './repos/RoleRepository'
import HolidayRepository from './repos/HolidayRepository'
import TravelWarrantRepository from './repos/TravelWarrantRepository'
import WorkplaceRepository from './repos/WorkplaceRepository'
import EmployeeRoleRepository from './repos/EmployeeRoleRepository'
import VacationTypeRepository from './repos/VacationTypeRepository'
import VacationRequestRepository from './repos/VacationRequestRepository'
import VacationResponseRepository from './repos/VacationResponseRepository'
import CollectiveVacationRepository from './repos/CollectiveVacationRepository'
import ScheduledOvertimeRepository from './repos/ScheduledOvertimeRepository'
import TravelWarrantSuggestionRepository from './repos/TravelWarrantSuggestionRepository'
import VehicleRepository from './repos/VehicleRepository'
import SupportTicketRepository from './repos/SupportTicketRepository'
import DocumentTypeRepository from './repos/DocumentTypeRepository'
import PartnerRepository from './repos/PartnerRepository'
import RealLocationRepository from './repos/RealLocationRepository'
import RecordBookTypeRepository from './repos/RecordBookTypeRepository'
import TransportTypeRepository from './repos/TransportTypeRepository'
import RecordBookRepository from './repos/RecordBookRepository'
import WarehouseRepository from './repos/WarehouseRepository'
import ProductRepository from './repos/ProductRepository'
import ManufacturerRepository from './repos/ManufacturerRepository'
import GroupationRepository from './repos/GroupationRepository'
import ProductSizeRepository from './repos/ProductSizeRepository'
import WorkplaceProductRulesRepository from './repos/WorkplaceProductRulesRepository'
import WorkplaceGroupationRulesRepository from './repos/WorkplaceGroupationRulesRepository'
import WarehouseTransactionRepository from './repos/WarehouseTransactionRepository'
import UserCheckoutFormRepository from './repos/UserCheckoutFormRepository'
import UserCheckoutFormStatusRepository from './repos/UserCheckoutFormStatusRepository'
import WarehouseStatesRepository from "./repos/WarehouseStatesRepository";
import ElectricityConstantRepository from "./repos/ElectricityConstantRepository";
import ElectricitySupplierRepository from "./repos/ElectricitySupplierRepository";
import ElectricityBillRepository from "./repos/ElectricityBillRepository";

import _ from 'lodash'
import {
  mapMutations,
  mapState
} from 'vuex'

export default {
  data () {
    let data =  {
        repositories: {
            auth: new AuthRepository(),
            user: new UserRepository(),
            sector: new SectorRepository(),
            role: new RoleRepository(),
            holiday: new HolidayRepository(),
            electricityConstant: new ElectricityConstantRepository(),
            electricitySupplier: new ElectricitySupplierRepository(),
            electricityBill: new ElectricityBillRepository(),
            workplace: new WorkplaceRepository(),
            employeeRole: new EmployeeRoleRepository(),
            vacationType: new VacationTypeRepository(),
            vacationRequest : new VacationRequestRepository(),
            collectiveVacation : new CollectiveVacationRepository(),
            vacationResponse : new VacationResponseRepository(),
            scheduledOvertime : new ScheduledOvertimeRepository(),
            travelWarrantSuggestion : new TravelWarrantSuggestionRepository(),
            travelWarrant : new TravelWarrantRepository(),
            vehicle: new VehicleRepository(),
            supportTicket: new SupportTicketRepository(),
            documentType: new DocumentTypeRepository(),
            partner: new PartnerRepository(),
            realLocation: new RealLocationRepository(),
            recordBookType: new RecordBookTypeRepository(),
            transportType: new TransportTypeRepository(),
            recordBook: new RecordBookRepository(),
            warehouse: new WarehouseRepository(),
            product: new ProductRepository(),
            manufacturer: new ManufacturerRepository(),
            groupation: new GroupationRepository(),
            productSize: new ProductSizeRepository(),
            workplaceProductRule: new WorkplaceProductRulesRepository(),
            workplaceGroupationRule: new WorkplaceGroupationRulesRepository(),
            warehouseTransaction: new WarehouseTransactionRepository(),
            userCheckoutForm: new UserCheckoutFormRepository(),
            userCheckoutFormStatus: new UserCheckoutFormStatusRepository(),
            warehouseStates: new WarehouseStatesRepository()
        },
        holidays: [],
        vacationRequests: [],
        collectiveVacations: [],
        VacationRequestStatuses: [

        ],
        TransactionStatuses: {
            IN : "in",
            OUT : "out",
            TRANSFER : "transfer",
            TRANSFER_IN : "transfer_in",
            TRANSFER_OUT : "transfer_out",
            DAMAGED_TRANSFER_IN : "damaged_transfer_in",
            DAMAGED_TRANSFER_OUT : "damaged_transfer_out",
            FIXED_TRANSFER_IN : "fixed_transfer_in",
            FIXED_TRANSFER_OUT : "fixed_transfer_out",
            BROKEN_TRANSFER_IN : "broken_transfer_in",
            BROKEN_TRANSFER_OUT : "broken_transfer_out",
        },
        UserRoles: {
            ADMIN: 'admin',
            DIRECTOR: 'director',
            REVISER: 'reviser',
            USER: 'user',
            LOGISTIC: 'logistic',
            REPORTER: 'reporter',
            ELECTRICIAN: 'electrician',
            RECORD_BOOKS: 'record_books',
            TRAVEL_WARRANTS: 'travel_warrants',
            WAREHOUSE: 'warehouse',
            COMPANY_USERS: 'company_users',
            VACATIONS: 'vacations',
            OVERTIME: 'overtime',
        },
        TravelWarrantSuggestionStatus: {
            NEW         : "New",
            APPROVED    : "Approved",
            DECLINED    : "Declined",
        },
        TravelWarrantMissions: [
            "Službeno putovanje",
            "Poslovni sastanak",
            "Transport EE otpada",
            "Obuka",
            "Ostavljanje vozila na servis",
            "Preuzimanje vozila sa servisa",
        ],
        UserGenders: {
            MALE: 'genders.male',
            FEMALE: 'genders.female',
        },
        ScheduledOvertimeReasons: [
            {key: 'a', value: 'više sile'},
            {key: 'b', value: 'iznenadnog povećanja obima posla i u drugim slučajevima kada je neophodno da se u određenom roku završi posao koji je planiran'},
            {key: 'c', value: 'završetka proces rada čije se trajanje nije moglo predvideti, a čije bi obustavljanje i prekidanje moglo naneti štetu poslodavcu'},
            {key: 'd', value: 'zamene iznenada odsutnog zaposlenog'},
            {key: 'e', value: 'ugovaranja poslova sa rokom u kome posao ne može da se obavi u redovno radno vreme'},
            {key: 'f', value: 'prijema, utovara i istovara otpada i druge robe'},
            {key: 'g', value: 'postojanja potrebe da se bez odlaganja izvrši određeni posao, odnosno radni zadatak koji se po propisima mora izvršiti u određenom roku'},
            {key: 'h', value: 'potrebe da se izvrši određeni neodložni montažni i remontni radovi i da se izvrše neodložne mere na postrojenjima'},
            {key: 'i', value: 'potrebe da se spreči propadanje sirovina ili repromaterijala ili otkloni kvar na sredstvima za rad'},
            {key: 'j', value: 'tehnološke složenosti  i prirode posla, usled čega se nije moglo predvideti u momentu ugovaranja roka, zvršetka posla'},
            {key: 'k', value: 'posla koji se nije mogao završiti u roku, zbog nedostatka pogonske energije, sirovina i drugog materijala potrebnog za obavljanje posla'},
            {key: 'l', value: 'drugih slučajeva za koje direktor proceni da nalažu potrebu za prekovremenim radom'},
            {key: 'm', value: 'sređivanja hale i radnog prostora'}
        ],
        timeout: 300,
        Currencies: [
          "RSD",
          "EUR",
          "USD"
        ],
        userCheckoutFormStatuses: {
          SUGGESTED    : "predloženo",
          GIVEN        : "izdato",
          RETURNED     : "vraćeno",
          BROKEN       : "oštećeno",
          DENIED       : "odbijeno",
          EXPENDABLE   : "potrošno"
        },
        warehouseTypes: [
          { name: "Servis", value: "servis"},
          { name: "Otpad", value: "otpad"},
          { name: "Potrošno", value: "potrošno"},
          { name: "Ostalo", value: "ostalo"}
        ]
    }

    return data;
  },
  computed: {
        ...mapState('app', ['fetching', 'me']),
        header () {
          return this.$route.name;
        }
  },
  methods: {
    ...mapMutations('app', ['setFetching', 'setMe']),
    getHolidays(){
        this.repositories.holiday.all().then((response) => {
            this.holidays = response.data.data;
        });
    },
    getUserNames(item){
        return _.map(item.users,'profile.name').join(', ');
    },
    getVacationRequests(){
      this.repositories.user.myVacationRequests().then((response) => {
              this.vacationRequests = response.data.data;
      });
    },
    getCollectiveVacations(){
          this.repositories.collectiveVacation.all().then((response) => {
              this.collectiveVacations = response.data.data;
        });
    },
    getOvertimeColor(item){
      if(item.pivot.attended == 0){
        return 'red';
      }
      return item.pivot.hours < item.hours ? 'warning' : 'blue';
    },
      getWorkingHours(item){
          let result = 0;



          if(item){
              let start = new Date( '01/01/2000 ' + item.start);
              let end = new Date( '01/01/2000 ' + item.end);
              result = (end - start)/ 60 / 1000;
            }
            let hours = Math.floor(result / 60);
            let minutes = result % 60;
            return (hours > 9 ? '' : '0') + hours + ':' + (minutes > 9 ? '' : '0') + minutes;
      },
    functionEvents (date) {

        let found = this.isVacationDate(date);
        if(found){
            return found;
        } else {
            found = this.isCollectiveVacationDate(date);

            if(found){
                return found;
            }
        }

        if (_.map(this.holidays, 'date').includes(date)) return true;

      return false
    },
    getLocaleVacationStatus(status){
          return this.$t('VacationRequestStatuses.' + status);
    },
    getLocalISOFormat(val){
      if(val && !_.isString(val)){
        return  new Date(val.getTime() - val.getTimezoneOffset() * 60000).toISOString().slice(0, 19).replace('T', ' ');
      }
      return val;
    },
    getLocaleDateFormat(str, withTime = false) {
      if (str != null) {
            let time = str.substring(11, str.length - 3);
            return str.substring(8, 10)+'/'+str.substring(5, 7)+'/'+str.substring(0, 4) + (withTime && time ? ' ' + time : '');
      }
      return '';
    },
    isVacationDate(date){
        let found = false;

        let result = this.vacationRequests.forEach((item) => {
            if(item.status != this.$t('VacationRequestStatuses.declined') && !item.isVacationDays && date >= item.start && date <= item.end){
                found = item.status == this.$t('VacationRequestStatuses.approved') ? '#30AF59' : '#ccc';
            }
        });

      return found;
    },
    getMaxOrder(productSize){
        if(productSize.product && productSize.product.productSizes) {
            return Math.max.apply(Math, productSize.product.productSizes.map(function(o) { return o.order; })) + 1;
        }
        return 1;
    },
    getVehicles(){
      this.repositories.vehicle.all().then((response) => {
          this.vehicles = response.data.data;
      })
    },
    isCollectiveVacationDate(date){
          let found = false;

          let result = this.collectiveVacations.forEach((item) => {
              if(date >= item.start && date <= item.end)
              {
                  found = 'indigo';
              }
          });

          return found;
    },
    hasAnyRole(roles){
        let result = false;

        roles.forEach((item) => {
           result = result || this.hasRole(item);
        });

        return result;
    },
    hasRole(role){
      let item = this.$store.state.app.me.roles.find(function(el){

          return el.name == role;

      });

      return !(item === undefined);
    },
    logout() {
      clearTimeout(this.$options.interval);
      let self = this;
      let route = '/employee';
      if(this.hasAnyRole([this.UserRoles.DIRECTOR, this.UserRoles.REVISER, this.UserRoles.ADMIN, this.UserRoles.LOGISTIC, this.UserRoles.REPORTER])){
          route = '/login'
      }
      this.$auth.logout().then(function () {
      }).catch(function(){

      }).finally(function() {
          self.$router.push(route);
      });
    },
    hoursConverter(val) {
      if(val < 24) {
        return val + ' ' + this.$t('DateTime.hours');
      }
      if(val < 720) {
        return val / 24 + ' ' + this.$t('DateTime.days');
      }

      return val / 30 / 24 + ' ' + this.$t('DateTime.months');
    },
    getAvailableStatuses(currentStatus, initial = false){
        let statuses = [
            {
                value: this.userCheckoutFormStatuses.SUGGESTED,
                text: this.$t('Pages.UserCheckoutForms.status.suggested')
            },
            {
                value: this.userCheckoutFormStatuses.GIVEN,
                text: this.$t('Pages.UserCheckoutForms.status.given')
            },
            {
                value: this.userCheckoutFormStatuses.RETURNED,
                text: this.$t('Pages.UserCheckoutForms.status.returned')
            },
            {
                value: this.userCheckoutFormStatuses.DENIED,
                text: this.$t('Pages.UserCheckoutForms.status.denied')
            },
            {
                value: this.userCheckoutFormStatuses.EXPENDABLE,
                text: this.$t('Pages.UserCheckoutForms.status.expendable')
            },
        ];
        if(initial){
            return statuses;
        }
        if(currentStatus === 'predloženo') {
            statuses = [
                {
                    value: this.userCheckoutFormStatuses.SUGGESTED,
                    text: this.$t('Pages.UserCheckoutForms.status.suggested')
                },
                {
                    value: this.userCheckoutFormStatuses.GIVEN,
                    text: this.$t('Pages.UserCheckoutForms.status.given')
                },
                {
                    value: this.userCheckoutFormStatuses.DENIED,
                    text: this.$t('Pages.UserCheckoutForms.status.denied')
                },
            ]
        }
        if(currentStatus === 'izdato') {
            statuses = [
                {
                    value: this.userCheckoutFormStatuses.GIVEN,
                    text: this.$t('Pages.UserCheckoutForms.status.given')
                },
                {
                    value: this.userCheckoutFormStatuses.RETURNED,
                    text: this.$t('Pages.UserCheckoutForms.status.returned')
                },
                {
                    value: this.userCheckoutFormStatuses.BROKEN,
                    text: this.$t('Pages.UserCheckoutForms.status.broken')
                },
            ]
        }
        if(currentStatus === 'odbijeno') {
            statuses = [
                {
                    value: this.userCheckoutFormStatuses.DENIED,
                    text: this.$t('Pages.UserCheckoutForms.status.denied')
                },
            ]
        }
        if(currentStatus === 'vraćeno') {
            statuses = [
                {
                    value: this.userCheckoutFormStatuses.RETURNED,
                    text: this.$t('Pages.UserCheckoutForms.status.returned')
                },
            ]
        }
        if(currentStatus === 'oštećeno') {
            statuses = [
                {
                    value: this.userCheckoutFormStatuses.BROKEN,
                    text: this.$t('Pages.UserCheckoutForms.status.broken')
                },
            ]
        }
        if(!currentStatus) {
            statuses = [
                {
                    value: this.userCheckoutFormStatuses.SUGGESTED,
                    text: this.$t('Pages.UserCheckoutForms.status.suggested')
                },
                {
                    value: this.userCheckoutFormStatuses.GIVEN,
                    text: this.$t('Pages.UserCheckoutForms.status.given')
                },
                {
                    value: this.userCheckoutFormStatuses.EXPENDABLE,
                    text: this.$t('Pages.UserCheckoutForms.status.expendable')
                },
            ]
        }

        return statuses;
    }
  },
    created(){

    },
    mounted() {
        this.VacationRequestStatuses = [
            {
                key: 'requested',
                value: this.$t('VacationRequestStatuses.requested')
            },
            {
                key: 'pending',
                value: this.$t('VacationRequestStatuses.pending')
            },
            {
                key: 'approved',
                value: this.$t('VacationRequestStatuses.approved')
            },
            {
                key: 'declined',
                value: this.$t('VacationRequestStatuses.declined')
            },
        ];
    }

}
</script>
